import $ from 'jquery';

import createBehavior from '../create-behavior';


export default () => {
  class PromoDates {
    constructor($el, context, settings) {
      $el.find(".promo__dates-item").on('click', function () {
        $(".promo__dates-item").removeClass('promo__dates-item--active');
        $(this).toggleClass('promo__dates-item--active')
      });
    }
  }

  createBehavior('.promo__dates', 'PromoDates', PromoDates);
}



// WEBPACK FOOTER //
// ./js/src/behaviors/promo-dates.js